import { Outlet } from 'react-router'

export const handle = {
	breadcrumb() {
		return { name: 'Tools', url: '/tools' }
	},
}

export default function ToolsLayout() {
	return <Outlet />
}
